const RETURN_PATH_KEY = 'impersonationReturnPath';

/** Fallback after leaving impersonation when no path was stored. */
export const DEFAULT_IMPERSONATION_RETURN_PATH = '/admin/impersonate';

/**
 * HashRouter return path from the current location (pathname + search).
 * @param {{ pathname?: string, search?: string } | null | undefined} location
 * @returns {string}
 */
export function buildImpersonationReturnPath(location) {
  const pathname = typeof location?.pathname === 'string' ? location.pathname : '';
  const search = typeof location?.search === 'string' ? location.search : '';
  const path = `${pathname}${search}`;
  return isSafeImpersonationReturnPath(path) ? path : DEFAULT_IMPERSONATION_RETURN_PATH;
}

/** @param {unknown} hashPath */
export function isSafeImpersonationReturnPath(hashPath) {
  return typeof hashPath === 'string' && hashPath.startsWith('/') && !hashPath.startsWith('//');
}

/**
 * Mémorise la route HashRouter à reprendre après la sortie d'impersonation.
 * @param {string} hashPath - ex. '/admin/feedback'
 */
export function setImpersonationReturnPath(hashPath) {
  try {
    if (isSafeImpersonationReturnPath(hashPath)) {
      sessionStorage.setItem(RETURN_PATH_KEY, hashPath);
    }
  } catch {
    /* ignore */
  }
}

/** Lit et efface la route de retour mémorisée (défaut : /admin/impersonate). */
export function consumeImpersonationReturnPath() {
  try {
    const path = sessionStorage.getItem(RETURN_PATH_KEY);
    sessionStorage.removeItem(RETURN_PATH_KEY);
    if (isSafeImpersonationReturnPath(path)) return path;
  } catch {
    /* ignore */
  }
  return DEFAULT_IMPERSONATION_RETURN_PATH;
}

/**
 * Rechargement complet vers l'accueil après le début d'une impersonation.
 *
 * Sécurité : un full reload garantit qu'aucune donnée de l'utilisateur précédent
 * (state React en mémoire, listeners Firestore encore actifs) ne reste accessible.
 * La persistance disque Firestore étant désactivée et le custom token n'étant jamais
 * stocké, il ne subsiste rien de réutilisable côté client après le rechargement.
 */
export function reloadToAccountHome() {
  try {
    sessionStorage.removeItem('impersonation');
  } catch {
    /* ignore */
  }
  // HashRouter : on force l'accueil puis un rechargement dur du document.
  window.location.hash = '/';
  window.location.reload();
}

/**
 * Rechargement complet après la fin d'une impersonation.
 * Retourne au panneau admin mémorisé (ex. /admin/impersonate) ou au fallback admin.
 */
export function reloadAfterImpersonationEnd() {
  try {
    sessionStorage.removeItem('impersonation');
  } catch {
    /* ignore */
  }
  window.location.hash = consumeImpersonationReturnPath();
  window.location.reload();
}
